import { useEffect, useCallback } from 'react';
import { webSocketService } from '../services/websocket.service';

export const useWebSocket = (conversationId?: string) => {
    useEffect(() => {
        // Resume an existing conversation only. Cold starts connect via
        // ensureConversationSession on the first customer message.
        if (conversationId) {
            webSocketService.connect({ conversationId });
        }

        return () => {
            webSocketService.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const sendMessage = useCallback((message: any) => {
        webSocketService.sendMessage(message);
    }, []);

    const subscribe = useCallback((event: string, callback: (data: any) => void) => {
        webSocketService.subscribe(event, callback);
        return () => {
            webSocketService.unsubscribe(event, callback);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conversationId]);

    return {
        sendMessage,
        subscribe,
        isConnected: webSocketService.isConnected(),
    };
};
